import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import * as React from 'react';
import Analytics from 'src/api/services/analytics/analytics';
import { useAuth } from 'src/shared/hooks/use-auth';

import { SidebarWrapper } from './components/wrapper';

export interface CatalogueProps {
  isOpen: boolean;
  onToggleSidebar?: () => void;
  isActive: (arg: string) => boolean;
  categories: {
    name: string;
    slug: string;
    color: string;
  }[];
}

const analyticsHandler = (category) => {
  Analytics.track('Lesson Category Select', {
    'Lesson Category': category,
  });
};

export const CatalogueSideBar = ({
  isOpen,
  onToggleSidebar,
  isActive,
  categories,
}: CatalogueProps): JSX.Element => {
  const authData = useAuth((s) => s.userDetails);
  const router = useRouter();
  const orgId = router?.query?.orgId;
  const mode = router?.query?.mode;

  return (
    <SidebarWrapper isOverview isOpen={isOpen} onToggle={onToggleSidebar}>
      {/* {authData?.authentication === 'authorised' && (
        <Link href={`/${mode}/${orgId}/dashboard`}>
          <a>
            <button className="mb-30 text-blue-500 px-24">
              <LeftArrowIcon className="mr-13 text-sm mt-2" />
              <span className="text-sm font-medium">Back to home</span>
            </button>
          </a>
        </Link>
      )} */}
      <div className="px-24 pt-16">
        <p className="font-medium text-xs text-gray-500 mb-8">Categories</p>
        {categories.map((category) => (
          <Link
            href={
              authData?.authentication === 'authorised'
                ? `/${mode}/${orgId}/catalog/category/${category.slug}`
                : `/catalog/category/${category.slug}`
            }
            key={category.slug}
          >
            <a
              className={classNames({
                'font-medium text-sm text-gray-600': true,
                'text-primary-500 bg-primary-100 hover:bg-blue-200 rounded': isActive(
                  category.slug
                ),
              })}
            >
              <div
                className="py-10 min-w-40 flex flex-row"
                role="button"
                tabIndex={0}
                onClick={() => {
                  analyticsHandler(category.name);
                }}
                onKeyPress={() => {
                  analyticsHandler(category.name);
                }}
              >
                <svg height="20" width="20" className="mr-4">
                  <circle cx="7" cy="10" r="6" stroke={category.color} fill={category.color} />
                </svg>
                <span>
                  {category.name.length > 25
                    ? `${category?.name.substring(0, 25)}...`
                    : category.name}
                </span>
              </div>
            </a>
          </Link>
        ))}
      </div>
      {/* <hr></hr> */}
      {/* <Link href={`/catalog/category/recommendations`} key={'recommendations'}>
        <a
          className={classNames({
            'font-medium text-sm text-gray-600 py-10 min-w-40': true,
            'text-primary-500 bg-primary-100 hover:bg-blue-200 rounded': isActive('recommendations')
          })}>
          Recommendations
        </a>
      </Link> */}
    </SidebarWrapper>
  );
};
